import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-coursecomplete',
  templateUrl: './coursecomplete.component.html',
  styleUrls: ['./coursecomplete.component.css']
})
export class CoursecompleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
